import { action, observable, computed } from 'mobx';
import { IBasicToutProps } from '~exported/basic-tout/BasicTout';
import { ViewController } from '@estee/elc-service';
import { emit, events } from '@estee/elc-service-bus';
import { INodeContent } from '~domain/entities/Node';
import { ToutLinkClickedUseCase } from '~use-cases/ToutLinkClickedUseCase';

export class BasicToutViewController extends ViewController {
    @observable public _content: Map<number, INodeContent>;

    constructor() {
        super();
        this._content = new Map();
    }

    @action
    public loaded = async (props: IBasicToutProps) => {
        this.isLoading = true;
        const { nid, layout, data } = props.config;
        this.content = {
            nid,
            layout,
            data
        };

        emit(events.BASIC_TOUT_LOADED, {});

        this.isLoading = false;
    };

    public redirectToSiteUrl = (siteUrl: string) => {
        const toutLinkClickedUseCase = new ToutLinkClickedUseCase(siteUrl);
        toutLinkClickedUseCase.execute();
    };

    @computed
    get data() {
        return {
            content: this._content
        };
    }

    public getContent(nid: number) {
        return this._content.get(nid);
    }

    public set content(input: INodeContent) {
        const { nid } = input;
        this._content.set(nid, { ...input });
    }
}
